import { toast } from "sonner"
import { downloadDocuments } from "../api/download_documents"

export const handleDownloadDocuments = async (project_id: string) => {
    try {
        toast.success("Downloading documents...")
        await downloadDocuments(project_id)
        toast.success("Documents downloaded successfully")
    } catch (error) {
        if (error instanceof Error) {
            if (error.message.includes("404")) {
                toast.error("Error downloading documents. The project may not have any documents.")
            } else {
                toast.error("Error downloading documents: " + error.message)
            }
        } else {
            toast.error("Error downloading documents: An unknown error occurred")
        }
    }
}